import React, { useState, useEffect } from "react";
import {
  Space,
  Row,
  Col,
  Switch,
  Form,
  Button,
  message,
  Skeleton,
  Divider,
  Drawer
} from "antd";
import MeetingRoomInputs from "../inputs/meetingRoom";
import { gql, useMutation, useLazyQuery } from "@apollo/client";
import DeleteCoreProduct from "@general/deleteCoreProduct";
import moment from "moment-jalaali";
import ContractTemplateEditor from "@general/contractTemplateEditor";
const UPDATEMEETINGROOM = gql`
  mutation updateMeetingRoom(
    $updateMeetingRoomInput: UpdateMeetingRoomInput!
    $id: ID!
  ) {
    updateMeetingRoom(updateMeetingRoomInput: $updateMeetingRoomInput, id: $id)
  }
`;

const GETPRODUCT = gql`
  query ($id: ID!) {
    getProduct(id: $id) {
      createdAt
      updatedAt
      contract
      name
      description
    }

    getProductContractVariable{
        name
        title
      }
  }
`;

function MeetingRoomDtails({ id, onDataUpdate }) {
  const [form] = Form.useForm();
  const [error, setError] = useState(null);
  const [editable, setEditable] = useState(false);
   const [meetingRoomDrawer, setMeetingRoomDrawer] = useState(false);
    const [meetingRoomContract, setMeetingRoomContract] = useState("<html></html>");
  const [initialData, setInitialData] = useState({});
const [productContractVars, setProductContractVars] = useState(null);
  const [runUpdateMeetingRoom, updateMeetingRoom] = useMutation(
    UPDATEMEETINGROOM,
    {
      onCompleted() {
        message.success("خدمت بروزرسانی شد.");
        onDataUpdate();
      },
      onError(err) {
        console.log("خطا: " + err.message);
        message.error("مشکلی پیش آمده! خدمت بروزرسانی نشد.");
      },
    }
  );

  const doUpdateData = (updateMeetingRoomInput) => {
    runUpdateMeetingRoom({
      variables: {
        id,
         updateMeetingRoomInput: {
          ...updateMeetingRoomInput,
          contract: meetingRoomContract,
        },
      },
    });
  };
  const [getServiceData, serviceData] = useLazyQuery(GETPRODUCT, {
    fetchPolicy: "no-cache",
    onCompleted({ getProduct, getProductContractVariable }) {
      setProductContractVars(getProductContractVariable);
      console.log(getProduct);
      
      const { createdAt, updatedAt, name, description,contract } = getProduct;
      const serviceData = {
        name,
        contract,
        description,
      };
      form.setFieldsValue(serviceData);
      setMeetingRoomContract(contract);
      setInitialData({
        createdAt: createdAt && moment(createdAt).format("jYYYY/jMM/jDD"),
        updatedAt: updatedAt && moment(updatedAt).format("jYYYY/jMM/jDD"),
        contract,
      });
    },
  });
  useEffect(() => {
    if (id) {
      getServiceData({
        variables: {
          id,
        },
      });
    }
    setEditable(false);
  }, [id]);
  const { createdAt, updatedAt } = initialData;
 
  
  if (serviceData.loading)
    return (
      <>
        <Skeleton active round />
        <br />
        <Skeleton active round />
      </>
    );
  return (
    <div>
    <Drawer
            title={"تعهدنامه استفاده از اتاق جلسات"}
            placement="top"
            open={meetingRoomDrawer}
            onClose={() => setMeetingRoomDrawer(false)}
            height={550}
          >
            <ContractTemplateEditor
              contract={meetingRoomContract}
              onCloseDrawer={() => setMeetingRoomDrawer(false)}
              onEditContract={(newContract) => setMeetingRoomContract(newContract)}
              helpVars={productContractVars}
            />
          </Drawer>
      <Row>
        <Col sm={12} xs={24}>
          <Space align="">
            <p>تاریخ ثبت: </p>
            {createdAt}
          </Space>
        </Col>
        <Col sm={12} xs={24}>
          <Space align="">
            <p>آخرین بروزرسانی: </p>
            {updatedAt}
          </Space>
        </Col>
      </Row>
      <Divider />
      <Row>
        <Space align>
          <p>ویرایش: </p>
          <Switch onChange={() => setEditable(!editable)} />
        </Space>
      </Row>
      <Form
        layout="vertical"
        onFinish={doUpdateData}
        form={form}
        disabled={!editable}
      >
        <Row gutter={15}>
          <Col xs={24} lg={24}>
            <MeetingRoomInputs error={error} onSetMeetingRoomDrawer={setMeetingRoomDrawer}/>
          </Col>
        </Row>
        <Space>
          <Button
            type="primary"
            htmlType="submit"
            loading={updateMeetingRoom.loading && true}
          >
            بروزرسانی
          </Button>
          <DeleteCoreProduct
            id={id}
            onDeleteCoreProduct={onDataUpdate}
            error={error}
          >
            <Button danger>حذف</Button>
          </DeleteCoreProduct>
        </Space>
      </Form>
    </div>
  );
}

export default MeetingRoomDtails;
